// extracted by mini-css-extract-plugin
export default {"knowledgeBase":"KnowledgeBase__knowledgeBase___x0O2u","knowledgeBaseBtn":"KnowledgeBase__knowledgeBaseBtn___iTyWE","folderFilledIcon":"KnowledgeBase__folderFilledIcon___p39UH"};